import React from 'react';
import PropTypes from 'prop-types';

const Upi = ({ fill, theme, ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_600_7552)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5657 9.91679L10.4741 1.97512C10.4052 1.81152 10.286 1.67416 10.1337 1.58304C9.9814 1.49193 9.80398 1.45182 9.62729 1.46856C9.4506 1.4853 9.28387 1.55801 9.15138 1.67611C9.0189 1.7942 8.92758 1.95151 8.89072 2.12512L8.33239 3.96679L7.64905 6.38346L8.79905 8.61679L9.48239 6.19179L9.90739 4.67512L12.7157 10.1085L6.88239 15.5251L7.41572 13.6085L8.33239 10.4918L5.89072 12.7085L4.99905 15.8335L4.39072 17.9835C4.33897 18.161 4.34774 18.3507 4.41563 18.5226C4.48352 18.6946 4.60668 18.8391 4.76572 18.9335C4.92784 19.0438 5.12368 19.0934 5.31879 19.0736C5.51389 19.0538 5.69576 18.9658 5.83239 18.8251L14.3824 10.9168C14.519 10.7937 14.6111 10.6289 14.6442 10.448C14.6774 10.2671 14.6498 10.0803 14.5657 9.91679Z"
        fill="#6B6C7B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1331 9.34985L9.51646 6.19152L8.33313 3.96652L7.0498 1.40819C6.97422 1.25591 6.85389 1.13039 6.70493 1.04847C6.55598 0.966542 6.38553 0.932132 6.21646 0.949854C6.04523 0.962494 5.88208 1.02772 5.74932 1.13661C5.61657 1.2455 5.52069 1.39273 5.4748 1.55819L0.991463 17.3915C0.94099 17.567 0.949532 17.7542 1.01578 17.9243C1.08202 18.0944 1.2023 18.2381 1.35813 18.3332C1.51548 18.4338 1.70205 18.4786 1.88793 18.4605C2.0738 18.4423 2.24819 18.3623 2.38313 18.2332L4.9998 15.8332L7.39146 13.6165L10.9415 10.3582C11.0814 10.2356 11.1762 10.0698 11.211 9.88703C11.2457 9.7043 11.2183 9.51521 11.1331 9.34985ZM8.33313 10.4915L5.89146 12.7082L3.45813 14.9999L6.5248 4.16652L7.68313 6.38319L8.83313 8.61652L9.31646 9.55819L8.33313 10.4915Z"
        fill="#6B6C7B"
      />
      <path
        d="M15.1424 8.60843C14.3782 8.61502 13.6329 8.84744 13.0005 9.27648C12.368 9.70552 11.8765 10.312 11.5878 11.0197C11.2992 11.7273 11.2262 12.5045 11.3781 13.2535C11.53 14.0025 11.9 14.6899 12.4416 15.2292C12.9832 15.7684 13.6721 16.1355 14.4218 16.2842C15.1714 16.4329 15.9483 16.3566 16.6547 16.065C17.3611 15.7733 17.9655 15.2792 18.3919 14.6449C18.8182 14.0106 19.0474 13.2644 19.0507 12.5001C19.0507 11.9876 18.9495 11.4802 18.7529 11.007C18.5563 10.5337 18.2682 10.104 17.905 9.74237C17.5419 9.38077 17.1109 9.09446 16.6368 8.89987C16.1627 8.70528 15.6549 8.60624 15.1424 8.60843ZM17.1174 11.9001L15.0007 14.0251C14.8879 14.1312 14.7389 14.1902 14.5841 14.1902C14.4292 14.1902 14.2802 14.1312 14.1674 14.0251L13.1924 13.0501C13.0722 12.9245 13.0051 12.7573 13.0051 12.5834C13.0051 12.4096 13.0722 12.2424 13.1924 12.1168C13.317 11.9946 13.4846 11.9262 13.6591 11.9262C13.8336 11.9262 14.0011 11.9946 14.1257 12.1168L14.5924 12.5834L16.2591 10.9584C16.3203 10.897 16.393 10.8482 16.4731 10.8149C16.5531 10.7816 16.639 10.7645 16.7257 10.7645C16.8125 10.7645 16.8983 10.7816 16.9784 10.8149C17.0585 10.8482 17.1312 10.897 17.1924 10.9584C17.2495 11.0251 17.2928 11.1024 17.3199 11.1859C17.3471 11.2693 17.3574 11.3574 17.3505 11.4448C17.3435 11.5323 17.3193 11.6176 17.2793 11.6957C17.2393 11.7738 17.1843 11.8433 17.1174 11.9001Z"
        fill="#6B6C7B"
      />
    </g>
    <defs>
      <clipPath id="clip0_600_7552">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

Upi.propTypes = {
  fill: PropTypes.string,
  theme: PropTypes.object,
};

export default Upi;
